import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  return <header className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-114" data-mp="l7mila78w3l">
      <div className="container mx-auto px-6 md:px-12" data-id="element-115" data-mp="9kkx5ha27qpw">
        <div className="flex justify-between items-center" data-id="element-116" data-mp="9izzvjwd1toc">
          <div className="flex items-center" data-id="element-117" data-mp="1pxrqpsduysvj">
            <Link to="/" data-id="element-118" data-mp="1q0nqlm99nrmm">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2RuwY93x3ZTZ9LC7gBR1Jd/HM_Logo_Horizontal.jpg" alt="HiddenMatter" className="h-10 md:h-12" data-id="element-119" data-mp="1kzq97bw2z1m6" />
            </Link>
          </div>
          <nav className="hidden md:block" data-id="element-120" data-mp="elpv11f3kliq">
            <ul className="flex space-x-8" data-id="element-121" data-mp="jm43gkkm1xha">
              <li className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-122" data-mp="jn6vivto65ys">
                <button className="font-inter text-black hover:text-lime transition-colors" data-id="element-123" data-mp="3n4xd4ma9q266">
                  Services
                </button>
                {servicesOpen && <div className="absolute top-full left-0 pt-2" data-id="element-124" data-mp="v4jjxrz3duv">
                    <div className="bg-white shadow-lg rounded-md py-2 min-w-[200px]" data-id="element-125" data-mp="5mm97pojps0j">
                      <Link to="/perspective" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-126" data-mp="34cw62wncb5lo">
                        Perspective
                      </Link>
                      <Link to="/purpose" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-127" data-mp="2wcyio18cuhhn">
                        Purpose
                      </Link>
                      <Link to="/principles" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-128" data-mp="2icxjqrbnhk4t">
                        Principles
                      </Link>
                      <Link to="/practice" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-129" data-mp="2ndv151ou6a59">
                        Practice
                      </Link>
                    </div>
                  </div>}
              </li>
              <li data-id="element-130" data-mp="143zktmqaos9">
                <Link to="/about" className="font-inter text-black hover:text-lime transition-colors" data-id="element-131" data-mp="14m227zzhz8m">
                  About
                </Link>
              </li>
              <li data-id="element-132" data-mp="swbftsybnz64">
                <Link to="/contact" className="font-inter text-black hover:text-lime transition-colors" data-id="element-133" data-mp="svtlx2z4tx1d">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
          <div className="md:hidden" data-id="element-134" data-mp="o41ruigrp96h">
            <button className="text-black" data-id="element-135" data-mp="o30j4kn84yrx">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6" data-id="element-136" data-mp="1bueaan9n2obb">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" data-id="element-137" data-mp="3p272ss7igxfc" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>;
};
export default Navbar;